import _ from 'lodash';
import {allPoses} from '../gameHelpers';
import posed from 'react-pose';
import {keysToSingleValue} from '../utils/objectFactory';

const enterPose = 'initial';
const exitPose = 'void';

const delay = 500;
const duration = 1000;

export const Section = posed.div({
    [enterPose]: {
        opacity: 1,
        delay,
        transition: {duration: 0},
    },
    [exitPose]: {
        opacity: 0,
    },
});

export const Paper = posed.div({
    enter: {
        rotate: 0,
    },
    exit: {
        rotate: 90,
        transition: {
            ease: 'easeIn',
            duration: 650,
        },
    },
});

export const ScoreBox = posed.div({
    [enterPose]: {
        x: 0,
        delay,
        transition: {ease: 'easeOut', duration},
    },
    [exitPose]: {
        x: props => `${props.teamDirection * 20}vw`,
    },
});

export const InfoButtonIcon = posed.div({
    [enterPose]: {
        x: 0,
        delay,
        transition: {ease: 'easeOut', duration},
    },
    [exitPose]: {
        x: '20vw',
    },
});

export const ScorePanel = posed.div({
    result: {
        top: 0,
        applyAtStart: {bottom: 'auto', 'z-index': 3},
        flip: true,
        transition: {
            ease: 'easeOut',
            delay: 500,
            duration: 1500,
        },
    },
});

export const GameEndMask = posed.div({
    result: {
        scaleY: 1,
        transition: {ease: 'easeIn', duration: 1000},
    },
    ...keysToSingleValue(_.without(allPoses, 'result'), {
        scaleY: 0,
    }),
});
